import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e35093b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "inheritance-control-icon__wrapper" };
import { computed, toRef } from "vue";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import { useBuiltComponent, useBuiltComponentVariable, useComponentDisplayName, } from "src/shared/store/component-built/composables";
import { useComponentVariableImmediateParentComponentId } from "src/shared/store/component-graph-v2/composables/useComponentVariableImmediateParentCompnentId";
import { useComponentVariableImpactSummary } from "src/shared/store/component-graph-v2/composables/useComponentVariableImpactSummary";
import { useComponentVariableChildComponentIds } from "src/shared/store/component-graph-v2/composables/useComponentVariableChildComponentIds";
import { useBuiltComponentSetting } from "src/shared/store/component-built/composables/useBuiltComponentSetting";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableNodeIcon',
    props: {
        componentId: {},
        variableName: {},
        source: {},
        variableNodeType: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableImmediateParentComponentId } = useComponentVariableImmediateParentComponentId(toRef(props, "componentId"), toRef(props, "variableName"));
        const { displayName: parentComponentDisplayName } = useComponentDisplayName(componentVariableImmediateParentComponentId);
        const { componentVariableChildComponentIds } = useComponentVariableChildComponentIds(toRef(props, "componentId"), toRef(props, "variableName"));
        const { componentVariableImpactSummary } = useComponentVariableImpactSummary(componentVariableChildComponentIds);
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const { builtComponentVariable } = useBuiltComponentVariable(toRef(props, "componentId"), toRef(props, "variableName"));
        const { builtComponent: sourceComponent } = useBuiltComponent(() => { var _a; return (_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.source_component_id; });
        const installedIntoSocketName = computed(() => {
            var _a;
            return ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.installed_into_socket) || null;
        });
        const { builtComponentSetting: installedIntoSocket } = useBuiltComponentSetting(() => { var _a; return (_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.source_component_id; }, () => installedIntoSocketName.value);
        const iconClass = computed(() => {
            const nodeTypeValue = props.variableNodeType;
            const sourceValue = props.source;
            if (props.source === "PARAMETER") {
                return "fa-solid fa-function";
            }
            if (nodeTypeValue === "ASSET") {
                return "fa-kit fa-variable-instance-linked";
            }
            if (nodeTypeValue === "MEDIATOR") {
                if (sourceValue === "INHERITED") {
                    return "fa-kit fa-variable-instance-linked";
                }
                else {
                    return "fa-kit fa-variable-instance-unlinked";
                }
            }
            if (nodeTypeValue === "INSTANCE") {
                if (sourceValue === "INHERITED") {
                    return "fa-kit fa-variable-instance-linked";
                }
                else {
                    return "fa-kit fa-variable-instance-unlinked";
                }
            }
            if (nodeTypeValue === "INDEPENDENT") {
                return "fa-kit fa-variable-instance-linked";
            }
            return "";
        });
        const tooltipMessage = computed(() => {
            var _a, _b;
            const nodeTypeValue = props.variableNodeType;
            const sourceValue = props.source;
            if (sourceValue === "PARAMETER") {
                return `Using parameter value provided by ${(_a = sourceComponent === null || sourceComponent === void 0 ? void 0 : sourceComponent.value) === null || _a === void 0 ? void 0 : _a.getDisplayName()} (${(_b = installedIntoSocket.value) === null || _b === void 0 ? void 0 : _b.getDisplayName()})`;
            }
            if (nodeTypeValue === "INDEPENDENT") {
                return "Not using any default values";
            }
            if (nodeTypeValue === "INSTANCE") {
                if (sourceValue === "INHERITED") {
                    return `Using "${parentComponentDisplayName.value}" default value`;
                }
                else {
                    return `Not using "${parentComponentDisplayName.value}" default value`;
                }
            }
            if (nodeTypeValue === "MEDIATOR") {
                if (sourceValue === "INHERITED") {
                    return `Using "${parentComponentDisplayName.value}" default value, Impact: ${componentVariableImpactSummary.value.description}`;
                }
                else {
                    return `Not using "${parentComponentDisplayName.value}" default value, Impact: ${componentVariableImpactSummary.value.description}`;
                }
            }
            if (nodeTypeValue === "ASSET") {
                return `Impact: ${componentVariableImpactSummary.value.description}`;
            }
            return "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Tooltip, { message: tooltipMessage.value }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("i", {
                            class: _normalizeClass(iconClass.value)
                        }, null, 2 /* CLASS */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["message"]));
        };
    }
});
